class Qa {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const modalTriggers = document.querySelectorAll(".js-modal-trigger")
    const modalContents = document.querySelectorAll(".js-qa-modal")
    const modalCloseBtns = document.querySelectorAll(".js-qa-modal-close")
    const modalOverlay = document.querySelector(".js-qa-modal-overlay")
    const body = document.querySelector("body")
    modalTriggers.forEach((trigger,i) => {

      trigger.addEventListener("click", () => {
        modalContents[i].classList.add("is-active")
        modalOverlay.classList.add("is-active")
        body.classList.add("is-scroll")
      })

      modalCloseBtns[i].addEventListener("click", () => {
        modalContents[i].classList.remove("is-active")
        modalOverlay.classList.remove("is-active")
        body.classList.remove("is-scroll")
      })

      modalOverlay.addEventListener("click", () => {
        modalContents[i].classList.remove("is-active")
        modalOverlay.classList.remove("is-active")
        body.classList.remove("is-scroll")
      })
    })

  }
}
